import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { 
  FaFacebook, FaLine, FaMapMarkerAlt, FaPhoneAlt, 
  FaEnvelope, FaClock 
} from 'react-icons/fa';

// ดึงข้อมูล Text จากต้นฉบับของคุณ
const LANGUAGE_TEXTS = {
  th: {
    home: 'หน้าแรก', products: 'สินค้า', services: 'บริการ', about: 'เกี่ยวกับเรา', contact: 'ติดต่อเรา',
    heroTitle: 'บริษัท แอสเซนท์ คอร์ปอเรชั่น จำกัด',
    contactUs: 'ติดต่อเรา',
    address: 'เลขที่ 214/201 หมู่ที่ 5 ตําบลแม่เหียะ \n อําเภอเมืองเชียงใหม่ จังหวัดเชียงใหม่ 50100',
    phone: 'โทรศัพท์:', line: 'ไลน์:', email: 'อีเมล:', 
    businessHours: ' จันทร์ - เสาร์ 08:00 - 17:00 น.',
    companyTagline: 'เรานำเสนออุปกรณ์การแพทย์ที่ช่วยให้ชีวิตของคุณเติบโตอย่างยั่งยืน',
    copyright: '© 2025 บริษัท แอสเซนท์ คอร์ปอเรชั่น จำกัด',
  }
};

const THEME = {
  primary: '#216488',
  secondary: '#155e75',
};

const Footer = ({ language = 'th' }) => {
  const location = useLocation();
  
  // ไม่แสดง Footer ในหน้า Admin
  if (location.pathname === '/admin') return null;

  const t = LANGUAGE_TEXTS[language] || LANGUAGE_TEXTS['th'];

  return (
    <footer style={{ background: '#1e293b', color: '#f8fafc', paddingTop: '4rem', borderTop: `4px solid ${THEME.primary}`, marginTop: 'auto' }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 2rem' }}>
        <div style={{ 
          display: 'grid', 
          gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))', 
          gap: '3rem',
          marginBottom: '3rem'
        }}>
          
          {/* คอลัมน์ที่ 1: โลโก้และสโลแกน */}
          <div>
            <h3 style={{ color: 'white', fontSize: '1.5rem', marginBottom: '1.2rem', fontWeight: '700' }}>
              {t.heroTitle}
            </h3>
            <p style={{ lineHeight: '1.8', opacity: 0.8, fontSize: '0.95rem', marginBottom: '1.5rem' }}>
              {t.companyTagline}
            </p>
            <div style={{ display: 'flex', gap: '15px' }}>
              <a href="https://www.facebook.com/p/ART-Medical-61576144820349/" target="_blank" rel="noreferrer" style={{ color: 'white', fontSize: '1.5rem' }}>
                <FaFacebook style={{ cursor: 'pointer' }} />
              </a>
              <a href="https://line.me/ti/p/~@730aicdq" target="_blank" rel="noreferrer" style={{ color: 'white', fontSize: '1.5rem' }}>
                <FaLine style={{ cursor: 'pointer' }} />
              </a>
            </div>
          </div>

          {/* คอลัมน์ที่ 2: เมนู */}
          <div>
            <h4 style={{ color: 'white', fontSize: '1.1rem', marginBottom: '1.5rem', borderLeft: `3px solid ${THEME.primary}`, paddingLeft: '10px' }}>เมนูหลัก</h4>
            <ul style={{ listStyle: 'none', padding: 0, lineHeight: '2.5' }}>
              <li><Link to="/" style={{ color: '#cbd5e1', textDecoration: 'none', fontSize: '0.95rem' }}>{t.home}</Link></li>
              <li><Link to="/products" style={{ color: '#cbd5e1', textDecoration: 'none', fontSize: '0.95rem' }}>{t.products}</Link></li>
              <li><Link to="/services" style={{ color: '#cbd5e1', textDecoration: 'none', fontSize: '0.95rem' }}>{t.services}</Link></li>
              <li><Link to="/about" style={{ color: '#cbd5e1', textDecoration: 'none', fontSize: '0.95rem' }}>{t.about}</Link></li>
              <li><Link to="/contact" style={{ color: '#cbd5e1', textDecoration: 'none', fontSize: '0.95rem' }}>{t.contactUs}</Link></li>
            </ul>
          </div>

          {/* คอลัมน์ที่ 3: การติดต่อ */}
          <div>
            <h4 style={{ color: 'white', fontSize: '1.1rem', marginBottom: '1.5rem', borderLeft: `3px solid ${THEME.primary}`, paddingLeft: '10px' }}>ข้อมูลติดต่อ</h4>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '15px', fontSize: '0.95rem', color: '#cbd5e1' }}>
              <div style={{ display: 'flex', gap: '12px' }}>
                <FaMapMarkerAlt style={{ color: THEME.primary, marginTop: '5px', flexShrink: 0 }} />
                <span style={{ lineHeight: '1.6', whiteSpace: 'pre-line' }}>{t.address}</span>
              </div>
              <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                <FaPhoneAlt style={{ color: THEME.primary, flexShrink: 0 }} />
                <a href="tel:0906187997" style={{ color: 'inherit', textDecoration: 'none' }}>090 618 7997</a>
              </div>
              <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                <FaLine style={{ color: THEME.primary, flexShrink: 0 }} />
                <a href="https://line.me/ti/p/~@730aicdq" target="_blank" rel="noreferrer" style={{ color: 'inherit', textDecoration: 'none' }}>@730aicdq</a>
              </div>
              <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                <FaEnvelope style={{ color: THEME.primary, flexShrink: 0 }} />
                <a href="mailto:ascentcorp.info@gmail.com" style={{ color: 'inherit', textDecoration: 'none' }}>ascentcorp.info@gmail.com</a>
              </div>
              
              <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                <FaClock style={{ color: THEME.primary, flexShrink: 0 }} />
                <span>{t.businessHours}</span>
              </div>
            </div>
          </div>

        </div>

        {/* ส่วนลิขสิทธิ์ */}
        <div style={{ 
          borderTop: '1px solid rgba(255,255,255,0.1)', 
          padding: '2rem 0', 
          textAlign: 'center', 
          fontSize: '0.85rem',
          color: '#94a3b8'
        }}>
          <p>{t.copyright}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;